import { Text } from '@user-portal/wikr-components';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { selectCancellationCandidates } from 'store/subscriptions/selectors';

import { sendAnalyticCancelOfferClick } from 'services/Analytics';

import { useSelector } from 'hooks';
import useModals from 'modals/hooks';
import { ModalName } from 'modals/types';

import { getValuesByKey } from 'helpers/utils';

import OutlinedButton from 'components/Buttons/OutlinedButton';
import InstallAppSteps from 'components/InstallAppSteps';
import Modal from 'components/Modal';

import { CancelFlowOffers, CancelOfferAction } from 'types/subscription';

import useCancelSubscriptionFlow from '../../../hooks/useCancelSubscriptionFlow';
import FullScreenModalHeader from '../../components/FullScreenModalHeader';

import * as S from './styles';

const offer = CancelFlowOffers.Login;

const CanNotLoginModal = () => {
    const { t } = useTranslation();
    const { closeModal, openModal } = useModals();
    const cancellationCandidates = useSelector(selectCancellationCandidates);

    const { onCancelSubscription } = useCancelSubscriptionFlow();

    const subscription_id = getValuesByKey(cancellationCandidates, 'external_id');

    const onBackButtonClick = () => {
        sendAnalyticCancelOfferClick({ eventLabel: { subscription_id, offer }, actionEvent: CancelOfferAction.Close });

        openModal(ModalName.CancellationReasonModal);
    };

    const onClose = useCallback(() => {
        sendAnalyticCancelOfferClick({ eventLabel: { subscription_id, offer }, actionEvent: CancelOfferAction.Close });

        closeModal();
    }, [closeModal, subscription_id]);

    return (
        <Modal
            fullscreen
            isOpen
            customStyles={{ padding: 0, display: 'flex', flexDirection: 'column' }}
            withRoundedCorners={false}
        >
            <FullScreenModalHeader closeModal={onClose} onBackButtonClick={onBackButtonClick} />

            <S.Container>
                <Text medium center mb={12} type="h4">
                    {t('cancellationReasons.canNotLogin.modal.title')}
                </Text>
                <Text center mb={32} type="large-text">
                    {t('cancellationReasons.canNotLogin.modal.subtitle')}
                </Text>

                <InstallAppSteps
                    downloadButtonText="cancellationReasons.canNotLogin.modal.goToApp"
                    cancelOfferName={offer}
                />

                <S.CancelSubscriptionButton>
                    <OutlinedButton
                        onClick={() => {
                            sendAnalyticCancelOfferClick({
                                eventLabel: { subscription_id, offer },
                                actionEvent: CancelOfferAction.Cancel,
                            });
                            onCancelSubscription();
                        }}
                        text={t('basics.button.cancelSubscription')}
                        backgroundColor="surface-main"
                        dataLocator="helpLoginCancelSubscriptionButton"
                    />
                </S.CancelSubscriptionButton>
            </S.Container>
        </Modal>
    );
};

export default CanNotLoginModal;
